import { render, staticRenderFns } from "./OpenSource.vue?vue&type=template&id=3e4f7549"
import script from "./OpenSource.vue?vue&type=script&lang=js"
export * from "./OpenSource.vue?vue&type=script&lang=js"
import style0 from "./OpenSource.vue?vue&type=style&index=0&id=3e4f7549&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports